import { CachingServiceImpl } from '../interfaces/caching-service';

let clientCache: CachingServiceImpl | null = null;

export const LS_KEY_DEBUG = 'debug-app-config';
export const LS_ROOT_CATEGORY_ID = 'root-category-id';
export const LS_KEY_PARTNER_ID = 'partnerId';
export const LS_KEY_ENDPOINT = 'endpoint';

export const FAKE_TTL = new Date().setFullYear(2040);

/**
 *
 */
export const tvpilGetLocalCache = () => {
  if (clientCache) {
    return clientCache;
  } else {
    throw new Error('Cache Service is not defined in TVPIL!!');
  }
};

/**
 *
 * @param cacheService
 */
export const tvpilSetCacheService = (cacheService: CachingServiceImpl) => {
  clientCache = cacheService;
};

export const getCacheValue = async <T>(key: string): Promise<T> => {
  const cache = tvpilGetLocalCache();
  return cache.getItem(key) as T;
};

export const setCacheValue = (key: string, value: unknown, ttl = FAKE_TTL) => {
  const cache = tvpilGetLocalCache();
  cache.setItem(key, value, ttl);
};
